import { render } from "./VetCard.vue?vue&type=template&id=681147a0&scoped=true"
import script from "./VetCard.vue?vue&type=script&lang=js"
export * from "./VetCard.vue?vue&type=script&lang=js"

import "./VetCard.vue?vue&type=style&index=0&id=681147a0&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681147a0"]])

export default __exports__